export const scrollToElementById = (id, offset = 0) => {
	const targetElement = document.getElementById(id);
	if (targetElement) {
		const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
		const adjustedPosition = elementPosition - offset; // Offset to scroll slightly above
		window.scrollTo({ top: adjustedPosition, behavior: "smooth" });
	}
};